import { render, staticRenderFns } from "./LynusIcon.vue?vue&type=template&id=16099ca8&scoped=true&"
import script from "./LynusIcon.vue?vue&type=script&lang=ts&"
export * from "./LynusIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LynusIcon.vue?vue&type=style&index=0&id=16099ca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16099ca8",
  null
  
)

export default component.exports